import { useAgentHold, setTcHold, useToast } from '@elva/ui';

/** Holding Treatment Coordinator (amendment 27 §9 → specs 36 + 37, shared store). */
export function useTcHold(): { onHold: boolean; setHold: (next: boolean) => void } {
  const hold = useAgentHold('treatment');
  const { toast } = useToast();
  return {
    onHold: hold.held,
    setHold: (next: boolean) => {
      setTcHold(next);
      toast({
        title: next ? 'Treatment Coordinator is on hold' : 'Treatment Coordinator is working again — 12 held messages go at their next window',
        variant: next ? 'warning' : 'success',
      });
    },
  };
}
